import React, {useEffect, useState} from "react";
import {Button, Container, Label, Modal, Segment} from "semantic-ui-react";
import AppListPage from "../../common/AppListPage";
import {SpecialGroupDataProvider} from "../service/SpecialGroupsDataProvider";
import {PaginateOptions} from "../../../agent";
import {SpecialGroup} from "../../dashboard";

interface Props {
    specialGroupIds?: string[],
    onChange?: (value: string[]) => void,
    disabled?: boolean
}

const SurveyCampaignSpecialGroups = (props: Props) => {
    const [specialGroupIds, setSpecialGroupIds] = useState<string[]>(props.specialGroupIds ?? []);
    const [showSelectList, setShowSelectList] = useState(false);

    useEffect(() => {
        if (props.onChange)
            props.onChange(specialGroupIds);
    }, [specialGroupIds]);

    return <>
        {showSelectList &&
            <Modal open={showSelectList}
                   onClose={() => setShowSelectList(false)}>
                <Modal.Content>
                    <Container>
                        <AppListPage<SpecialGroup, PaginateOptions>
                            provider={new SpecialGroupDataProvider()}
                            hideMenu={true}
                            multiSelect={true}
                            columns={[
                                {key: "name", name: "Наименование"}
                            ]}
                            selectedIds={specialGroupIds}
                            onSelectionChanged={(sel) =>
                                setSpecialGroupIds(sel.selectedIds)}
                        />
                    </Container>
                </Modal.Content></Modal>}
        <Segment padded color={"teal"}>
            <Label circular size={"large"}><b>{specialGroupIds.length}</b></Label> особых групп выбрано
            <Button floated={"right"} size={"small"} color={"teal"} content={"Изменить выбор"}
                    type={"button"}
                    disabled={props.disabled}
                    onClick={() => setShowSelectList(true)}/>
        </Segment>
    </>;
}

export default SurveyCampaignSpecialGroups;